(() => {
  if (window.deckGripDawnInitialized) return;
  window.deckGripDawnInitialized = true;

  document.addEventListener(
    'submit',
    async function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;

      const productForm = form.closest('product-form');
      if (!productForm) return;
      const section = form.closest('.shopify-section');
      if (!section) return;
      const addon = section.querySelector('[data-deck-grip-addon]');
      if (!addon) return;

      const selectedGrip = addon.querySelector('input[data-grip-option]:checked');
      const gripVariantId = selectedGrip ? selectedGrip.value : '';
      if (!gripVariantId) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const formData = new FormData(form);
      const deckVariantId = Number(formData.get('id'));
      const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);
      if (!deckVariantId) {
        console.error('Deck variant ID could not be found.');
        return;
      }

      const submitButton = productForm.querySelector('[type="submit"]');
      const spinner = productForm.querySelector('.loading__spinner');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      try {
        const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        const sections = cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map((section) => section.id)
          : ['cart-icon-bubble'];
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              { id: deckVariantId, quantity: quantity },
              { id: Number(gripVariantId), quantity: quantity },
            ],
            sections: sections,
            sections_url: window.location.pathname,
          }),
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add deck and grip.');
        }
        if (!data.key && Array.isArray(data.items) && data.items.length) data.key = data.items[0].key;
        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
          cart.renderContents(data);
        } else {
          window.location.href = `${root}cart`;
        }
      } catch (error) {
        console.error('Deck + grip add-on error:', error);
        alert('The deck and selected grip tape could not be added. Please try again.');
      } finally {
        if (submitButton) {
          submitButton.removeAttribute('aria-disabled');
          submitButton.classList.remove('loading');
        }
        if (spinner) spinner.classList.add('hidden');
      }
    },
    true
  );
})();
